import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import { Link } from "react-router-dom";

const categoriesData = [
  {
    title: "Insecticides",
    image: "/images/img/insecticide.jpg",
    link: "/category/insecticides",
  },
  {
    title: "Fungicides",
    image: "/images/img/fungicide.jpg",
    link: "/category/fungicides",
  },
  {
    title: "Herbicides",
    image: "/images/img/herbicide.jpg",
    link: "/category/herbicides",
  },
  {
    title: "Plant Growth Regulators",
    image: "/images/img/pgr.jpg",
    link: "/category/pgr",
  },
  {
    title: "Fertilizers",
    image: "/images/img/fertilizer.jpg",
    link: "/category/fertilizers",
  },
  {
    title: "NPK Fertilizer",
    image: "/images/img/npk.jpg",
    link: "/category/NPK-Fertilizer",
  },
];

const Categories = () => {
  return (
    <section className="section categories-section">
      <Container>

        {/* Section Heading (Common CSS) */}
        <div className="section-title fade-up">
          <h2>Product Categories</h2>
          <p>
            A complete range of crop care and plant nutrition solutions designed
            to support sustainable and productive farming.
          </p>
        </div>

        <Row>
          {categoriesData.map((cat, index) => (
            <Col lg={4} md={6} className="mb-4 fade-up" key={index}>
              <div className="category-card">

                <img
                  src={cat.image}
                  alt={cat.title}
                  className="img-fluid"
                />

                {/* Overlay */}
                <div className="category-overlay">
                  <h4>{cat.title}</h4>

                  <Link to={cat.link} className="category-btn">
                    View Products
                  </Link>
                </div>

              </div>
            </Col>
          ))}
        </Row>

      </Container>
    </section>
  );
};

export default Categories;
